import type { Dispatch } from 'redux'
import { connect } from 'react-redux'
import { CongratulationsComponent } from './CongratulationsComponent'
import type { RootState } from 'shared/store/reducers'
import { getUrlParams, resendMail } from 'shared/store/congratulations'
import { pageMetadata } from 'shared/store/metadata'

const mapStateToProps = (state: RootState) => {
    return {
        ...state.congratulationsPageState,
        authenticated: !!state.userState && !!state.userState.authenticated
    }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    sendMeta: (meta: any) => d(pageMetadata(meta)),
    getUrlParams: () => d(getUrlParams()),
    resendMail: (queen: string) => d(resendMail(queen))
})

const Congratulations = connect(
    mapStateToProps,
    mapDispatchToProps
)(CongratulationsComponent)

export { Congratulations }
